import { render, staticRenderFns } from "./QuizEnd.vue?vue&type=template&id=4480720a&scoped=true&"
import script from "./QuizEnd.vue?vue&type=script&lang=js&"
export * from "./QuizEnd.vue?vue&type=script&lang=js&"
import style0 from "./QuizEnd.vue?vue&type=style&index=0&id=4480720a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4480720a",
  null
  
)

export default component.exports